import diff from 'deep-diff';
import { CLASSROOM_MODULE_SAVE_CURRENT_SECTION } from '../actions';
import { createSection, patchSection } from '../api';
import { isContentEquivalent } from '../../utils/editor';
import * as classRoomSelectors from '../../selectors/classroom';
import * as selectors from '../selectors';
import setEditing from './setEditing.operation';

const isLocal = (id) => id.startsWith('local.');

const prepareForNetwork = (patch) => ({
  ...patch,
  content: patch.content && JSON.stringify(patch.content),
  writer: patch.writer && patch.writer.id ? patch.writer.id : patch.writer,
});

const hasChanges = (section, patch) => {
  const compareFns = {
    content: isContentEquivalent,
  };
  const arePropsDifferent = (prop) =>
    compareFns[prop]
      ? !compareFns[prop](section[prop], patch[prop])
      : !!diff(section[prop], patch[prop]);
  return Object.keys(patch).some(arePropsDifferent);
};

const saveSectionAction = (status, payload) => ({
  type: CLASSROOM_MODULE_SAVE_CURRENT_SECTION,
  status,
  payload,
});

const saveSectionStarted = saveSectionAction.bind(null, 'started');
const saveSectionSuccess = saveSectionAction.bind(null, 'success');
const saveSectionError = saveSectionAction.bind(null, 'error');

const saveSection = ({ id, patch, select, educatorOnly }) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const classRoomId = classRoomSelectors.currentClassRoomId(state);
  const section = id
    ? selectors.getMaterial(state, id)
    : selectors.currentSection(state);
  const sectionId = section.id;
  const local = isLocal(sectionId);

  if (!local && !hasChanges(section, patch)) {
    dispatch(setEditing(false));
    return;
  }

  try {
    dispatch(saveSectionStarted({ sectionId, patch }));
    const savedSection = local
      ? await createSection(
          classRoomId,
          {
            ...prepareForNetwork({ ...section, ...patch }),
            parent: section.parent,
          },
          sectionId
        )
      : await patchSection(classRoomId, sectionId, prepareForNetwork(patch));
    const payload = {
      classRoom: classRoomId,
      section: savedSection,
      oldSection: section,
    };
    dispatch(saveSectionSuccess(payload));
    if (select) {
      dispatch(select(savedSection.id, educatorOnly));
    }
  } catch (error) {
    dispatch(saveSectionError({ oldSection: section, error }));
  }
};

export default saveSection;
